export default __webpack_public_path__ + "static/media/2026scheduleph.cbff838d.png";